import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {PaginatedUsers} from "../models/paginated_users";

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private http: HttpClient) { }

  userTeams(userId: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/v1/auth/users/${userId}/teams`)
  }

  sendResetPasswordEmail(userId: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/v1/auth/users/${userId}/send-reset-password-email`, {})
  }

  list(searchParams: any): Observable<PaginatedUsers> {
    return this.http.get<PaginatedUsers>(`${environment.apiUrl}/api/v1/auth/users?search=${encodeURIComponent(searchParams?.search ?? '')}&page=${searchParams.currentPage}&page_size=${searchParams.pageSize}`);
  }

  show(userId: string): any {
    return this.http.get<any>(`${environment.apiUrl}/api/v1/auth/users/${userId}`)
  }

  assignedRoles(userId: string): any {
    return this.http.get<any>(`${environment.apiUrl}/api/v1/auth/users/${userId}/roles`)
  }

  availableRoles(internal: boolean, userId?: string): any {
    return this.http.post<any>(`${environment.apiUrl}/api/v1/auth/users/available-roles`, {internal, user_id: userId})
  }

  create(createParams: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/v1/auth/users`, createParams)
  }

  update(userId: string, updateParams: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/api/v1/auth/users/${userId}`, updateParams)
  }

  delete(userId: string): any {
    return this.http.delete<any>(`${environment.apiUrl}/api/v1/auth/users/${userId}`)
  }

  restore(userId: string): any {
    return this.http.put<any>(`${environment.apiUrl}/api/v1/auth/users/${userId}/restore`, {})
  }
}
